import './OldTeamView.scss'

import { ERROR, LOADING, READY, RELOADING, useVisualState } from '../../../hooks/useVisualState'
import React, { Fragment, useEffect, useState } from 'react'
import { Redirect, Route, Switch, useParams, withRouter } from 'react-router-dom'
import { Tab, Tabs } from '../../../components/Tabs/Tabs'

import GenericErrorModal from '../../../modules/GenericErrorModal/GenericErrorModal'
import Icon from '../../../components/Icon/Icon'
import Logo from '../../../components/Logo/Logo'
import OldTeamPlayersView from './OldTeamPlayersView'
import OldTeamTechnicalStaffView from './OldTeamTechnicalStaffView'
import TextLink from '../../../components/TextLink/TextLink'
import { oldGet } from '../../../helpers/requestOld'
import t from '../../../helpers/i18n'
import useForceUpdate from '../../../hooks/useForceUpdate'
import LoadingPanel from '../../../components/Loading/LoadingPanel'

const OldTeamView = () => {
  const [[teamStatus, team], setTeam] = useVisualState()
  const { teamId } = useParams()
  const [error, setError] = useState()
  const [update, forceUpdate] = useForceUpdate()

  useEffect(() => {
    setTeam(RELOADING)
    oldGet('/delegate/teams/' + teamId)
      .then(response => {
        setTeam(READY, response)
      })
      .catch(error => {
        setTeam(ERROR)
        setError(error)
      })
  }, [setTeam, teamId, update])

  return (
    <div className="main-content old-team-players-view">
      <div className="-page-header">
        <div className="-left label-extra-large-semibold">
          {team && <Logo size="extra-large" source={team.logo} alternative={<Icon size={32} icon='TeamsIcon' />} />}
          <div className="-data">
            <TextLink
              label={t('textLink.Back_to_teams')}
              labelOrientation="right"
              size="small"
              icon="ArrowLeftIcon"
              link="/cm/teams"
            />
            {team &&
              <Fragment>
                <div className="-team-name proper-noun-display-small-bold">{team.name}</div>
                <div className="-competition">
                  <div className='-data proper-noun-small-medium'>{team.category_name}</div>
                  <div className='-logo'><Logo size="tiny" source={team.category_logo} /></div>
                </div>
              </Fragment>
            }
          </div>
        </div>
        <div className="-center"></div>
      </div>

      <Tabs>
        <Tab title={t('menu.Players')} icon="PlayersIcon" to={"/cm/teams/" + teamId + "/players"} />
        <Tab title={t('menu.Technical_Staff')} icon="TechnicalStaffIcon" to={"/cm/teams/" + teamId + "/technical_staff"} />
      </Tabs>

      <Switch>
        <Route path="/cm/teams/:teamId/players">
          <OldTeamPlayersView team={team} onPlayersChanged={forceUpdate} />
        </Route>
        <Route path="/cm/teams/:teamId/technical_staff">
          <OldTeamTechnicalStaffView team={team} onStaffChanged={forceUpdate} />
        </Route>
        <Route exact path="/cm/teams/:teamId">
          <Redirect to={"/cm/teams/" + teamId + "/players"} />
        </Route>
      </Switch>

      {error && <GenericErrorModal error={error} i18nPrefix="OldTeamView" onCloseRequested={() => setError(false)} />}
      {teamStatus === LOADING && <LoadingPanel />}
    </div>
  )
}

export default withRouter(OldTeamView)
